import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { useNavigate } from 'react-router-dom';

const SimpleProposalPage = () => {
  const navigate = useNavigate();
  const [bidName, setBidName] = useState('');

  return (
    <MainLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate('/bid-management')}>
            <Icon name="ArrowLeft" size={20} />
          </Button>
          <div>
            <h1 className="text-3xl font-semibold text-foreground">Simple Proposal</h1>
            <p className="text-sm text-muted-foreground">A lightweight proposal for straightforward projects</p>
          </div>
        </div>

        <div className="bg-card rounded-xl border border-border p-6 max-w-xl">
          <div className="space-y-4">
            <Input
              label="Bid Name"
              type="text"
              required
              value={bidName}
              onChange={(e) => setBidName(e?.target?.value)}
              placeholder="Enter bid name"
            />
            <div className="flex items-center gap-3 pt-2">
              <Button variant="outline" onClick={() => navigate('/bid-management')}>Cancel</Button>
              <Button variant="default" iconName="Save" iconPosition="left" iconSize={16}>Save Proposal</Button>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SimpleProposalPage;
